import { AccountTypeType } from "@verivest/shared-components/src/api/enums";
import { AccountModel } from "@verivest/shared-components/src/api/models";
import { validateBrokerageAccReqAttr } from "./helpers/validateBrokerageAccReqAttr";
import { validateCustodiedAccReqAttr } from "./helpers/validateCustodiedAccReqAttr";
import {
  validateEntityReqAttr,
  validateTrustReqAttr,
} from "./helpers/validateEntityOrTrustReqAttr";
import { validateIndividualReqAttr } from "./helpers/validateIndividualReqAttr";
import { validateJointReqAttr } from "./helpers/validateJointReqAttr";

const validateAccount = (account: AccountModel | null | undefined) => {
  switch (account?.accountType) {
    case AccountTypeType.Individual:
      return validateIndividualReqAttr(account);
    case AccountTypeType.Joint:
      return validateJointReqAttr(account);
    case AccountTypeType.Entity:
      return validateEntityReqAttr(account);
    case AccountTypeType.Trust:
      return validateTrustReqAttr(account);
    default:
      return false;
  }
};

export const validateAccountRequiredAttributes = (
  account: AccountModel | null | undefined,
) => {
  try {
    switch (account?.accountType) {
      case AccountTypeType.Individual:
      case AccountTypeType.Joint:
      case AccountTypeType.Entity:
      case AccountTypeType.Trust:
        return validateAccount(account);
      case AccountTypeType.Brokerage:
        return (
          validateBrokerageAccReqAttr(account) &&
          validateAccount(account.custodiedOwner)
        );
      case AccountTypeType.Retirement:
      case AccountTypeType.CustodiedAccount:
        return (
          validateCustodiedAccReqAttr(account) &&
          validateAccount(account.custodiedOwner)
        );
      default:
        return false;
    }
  } catch (error) {
    console.error("Error validating account required attributes:", error);
    return false;
  }
};
